<template>
  <div class="home-header" :class="{ scrolled: isScrolled }">
    <div class="home-logo">
      <img src="@/assets/images/logo.png" alt="" />
    </div>
    <div class="home-nav">
      <ul>
        <li @click="go('/home')">
          <a :class="{ active: $route.path === '/home' }" href="javascript:">
            <span>{{ `首  页` }}</span>
          </a>
        </li>
        <li @click="go('/product')">
          <a href="javascript:" :class="{ active: $route.path === '/product' }">
            <span>{{ `产  品` }}</span>
          </a>
        </li>
        <li @click="go('/about')">
          <a href="javascript:" :class="{ active: $route.path === '/about' }">
            <span>{{ `关于我们` }}</span>
          </a>
        </li>
        <li @click="go('/news')">
          <a href="javascript:" :class="{ active: $route.path === '/news' }">
            <span>{{ `新闻动态` }}</span>
          </a>
        </li>
        <li @click="go('/partner')">
          <a href="javascript:" :class="{ active: $route.path === '/partner' }">
            <span>{{ `合作伙伴` }}</span>
          </a>
        </li>
        <li @click="go('/contact')">
          <a href="javascript:" :class="{ active: $route.path === '/contact' }">
            <span>{{ `联系我们` }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isScrolled: false
    };
    
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 0;
    },
    go(path) {
      this.$router.push({ path });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/layout/header.vue